import Commons from '../../../../Services/Common/Common';

const buildCopyContextMapper = () => ({
  SourceCoCd: (_, context) =>
    Commons.EncryptAES(String(context.sourceCoCd ?? '').trim()) || '',
  SourceCustCd: (_, context) =>
    Commons.EncryptAES(String(context.sourceCustCd ?? '').trim()) || '',
  TargetCoCd: (_, context) =>
    Commons.EncryptAES(String(context.targetCoCd ?? '').trim()) || '',
  TargetCustCd: (_, context) =>
    Commons.EncryptAES(String(context.targetCustCd ?? '').trim()) || '',
  SourceDepCd: (_, context) =>
    Commons.EncryptAES(String(context.sourceDepCd ?? '').trim()) || '',
  TargetDepCd: (_, context) =>
    Commons.EncryptAES(String(context.targetDepCd ?? '').trim()) || '',
  UserId: (_, context) => context.userInfo?.userid || '',
});

/**
 * 데이터 이관(DAT_BASIC) 스키마
 * - copy1: 전체 페이지 일괄 이관
 * - copy2: 메뉴(ProId) + 탭(TabKey, 빈값=해당 메뉴 전체 탭) 선택 이관
 */
export const DAT_BASIC_Schema = {
  fields: {
    migrationMode: { initial: 'PAGE', label: '이관 구분' },
    proId: { initial: '', label: '이관 페이지', required: 'Y' },
    tabKey: { initial: '', label: '이관 탭' },
    sourceCoCd: { initial: '', label: '원본 회사코드', required: 'Y' },
    sourceCustCd: { initial: '', label: '원본 사업장코드', required: 'Y' },
    targetCoCd: { initial: '', label: '대상 회사코드', required: 'Y' },
    targetCustCd: { initial: '', label: '대상 사업장코드', required: 'Y' },
    sourceDepCd: { initial: '', label: '원본 부서' },
    targetDepCd: { initial: '', label: '대상 부서' },
  },

  mapper: {
    copy1: buildCopyContextMapper(),
    copy2: {
      ...buildCopyContextMapper(),
      ProId: (_, context) =>
        Commons.EncryptAES(String(context.proId ?? '').trim()) || '',
      TabKey: (_, context) =>
        Commons.EncryptAES(String(context.tabKey ?? '').trim()) || '',
    },
    delete1: {
      TargetCustCd: (_, context) =>
        Commons.EncryptAES(String(context.targetCustCd ?? '').trim()) || '',
      ProId: (_, context) =>
        Commons.EncryptAES(String(context.proId ?? '').trim()) || '',
      TabKey: (_, context) =>
        Commons.EncryptAES(String(context.tabKey ?? '').trim()) || '',
    },
  },
};
